import { render } from "./AssistingAccounting.vue?vue&type=template&id=5be2289b"
import script from "./AssistingAccounting.vue?vue&type=script&lang=js"
export * from "./AssistingAccounting.vue?vue&type=script&lang=js"

import "./AssistingAccounting.vue?vue&type=style&index=0&id=5be2289b&lang=less"

import exportComponent from "D:\\cwzl\\four-cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__